import React from 'react';
import getContent, { init as initL10n } from 'pp-react-l10n';
import PropTypes from 'prop-types';

initL10n({
  content: (() => {
    if (typeof window !== 'undefined' && window.dictionary) {
      return window.dictionary;
    }
    if (typeof global !== 'undefined' && global.dictionary) {
      return global.dictionary;
    }
    return {};
  })(),
  onContentMissing: () => {}
});

const getErrorContent = getContent('merchanthub.errors');
const errorStyle = {
  WebkitBoxPack: 'space-evenly',
  MsFlexPack: 'space-evenly',
  justifyContent: 'space-evenly',
  display: 'flex',
  WebkitBoxOrient: 'vertical',
  WebkitBoxDirection: 'normal',
  MsFlexDirection: 'column',
  flexDirection: 'column',
  WebkitBoxAlign: 'center',
  MsFlexAlign: 'center',
  alignItems: 'center',
  padding: '40px 20px',
  textAlign: 'center',
  minHeight: '75vh'
};
const AppError = () => {
  return (
    <div style={errorStyle} className="appError-container">
      <h1>{getErrorContent('service.title')}</h1>
      <div>
        <a href="/merchantapps/appcenter">{getErrorContent('desc2')}</a>
      </div>
    </div>
  );
};

export default AppError;

AppError.propTypes = {
  location: PropTypes.object,
  staticContext: PropTypes.object
};
